<template>
	<v-container>
		<!-- MODAL MOR INFO-->
		<v-dialog v-model="moreInfo" persistent v-ripple="{ center: true }">
			<v-card>
				<v-card-title id="nameTitle">{{ infoObj.nombre }}</v-card-title>
				<v-card-subtitle class="pt-2">{{ infoObj.materia }}</v-card-subtitle>
				<v-card-text class="black--text">
					<div v-show="infoObj.salon"><b>Lugar:</b> {{ infoObj.salon }}<br /></div>
					<b>Email: </b
					><a :href="'mailto:' + infoObj.contacto">{{ infoObj.contacto }}</a> <br />
					<br />
					<div v-for="(dia, i) in infoObj.horario" v-bind:key="`dia-${i}`">
						<div v-if="dia[0]">
							<b> {{ getDiaSemana(i) }} </b>
							<ul>
								<div v-for="(hora, j) in dia" v-bind:key="`hora-${i}-${j}`">
									De {{ hora[0] }} a {{ hora[1] }}
								</div>
							</ul>
						</div>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="moreInfo = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- CONTENIDO -->
		<v-row>
			<v-col
				cols="6"
				md="4"
				v-for="(asesor, i) in asesores"
				:key="i"
				@click="openMoreInfo(i)"
			>
				<v-card height="100%">
					<v-card-title id="nameTitle">{{ asesor.nombre }}</v-card-title>
					<v-card-subtitle>{{ asesor.aporte }}</v-card-subtitle>
					<v-card-text class="black--text">{{ asesor.materia }}</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn text color="primary">
							Ver más
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<!-- NADA QUE MOSTRAR -->
		<nothing v-show="nothingToShow"></nothing>

		<!-- LOADING -->
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-container>
</template>

<script>
import { ASESORES_API } from "../apiConfig";
import { getDataModule } from "../db_save";

import Nothing from "../components/Nothing";

export default {
	data: () => ({
		asesores: [],
		nothingToShow: false,
		loading: true,
		moreInfo: false,
		infoObj: {}
	}),
	components: { Nothing },
	created() {
		this.getAsesores();
	},
	methods: {
		getAsesores() {
			//console.log("Get Asesores ", ASESORES_API);

			getDataModule("asesores", 1000 * 60 * 10, ASESORES_API)
				.then(asesores => {
					//console.log("Asesores: ", asesores);
					if (asesores.length > 0) {
						this.asesores = asesores;
					} else {
						this.asesores = [];
						this.nothingToShow = true;
					}
				})
				.catch(e => {
					console.error("Error ", e);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		openMoreInfo(idAsesor) {
			this.infoObj = this.asesores[idAsesor];
			this.moreInfo = true;

			this.$ua.trackEvent(
				`AsesoresInteraccion`,
				"NombreMoreInfo",
				this.asesores[idAsesor].nombre
			);

			this.$ua.trackEvent(
				`AsesoresInteraccion`,
				"MateriaMoreInfo",
				this.asesores[idAsesor].materia
			);
		},
		getDiaSemana(num) {
			let semana = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes"];
			return semana[num];
		}
	}
};
</script>

<style>
#nameTitle {
	word-break: break-word;
}
</style>
